export default Object.freeze({
  gen1: 1,
  gen2: 2,
  gen3: 3,
  gen4: 4,
  gen5: 5,
  gen6: 6,
  gen7: 7,
  gen8: 8,
  gen9: 9
});
